import { Button as ButtonAntD } from 'antd';
import styled from 'styled-components';

import { COLORS } from '../../../utils/theme/colors';

export const Wrapper = styled.div`
  margin: 0 auto;

  .ant-select-item.ant-select-item-option.ant-select-item-option-selected {
    background-color: ${({ theme }) => theme.hoveredDiv};
  }

  .ant-page-header-back-button:focus,
  .ant-page-header-back-button:hover {
    color: ${({ theme }) => theme.primary};
  }
`;

export const ChargeboxCircle = styled.div`
  background-color: ${COLORS.transparentDark};
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
`;

export const ChargeboxText = styled.div`
  font-weight: 300;
  font-size: 16px;

  &::after {
    content: '';
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${COLORS.transparentIcon};
    margin: 0 24px;
  }
`;

export const Button = styled(ButtonAntD)`
  height: 50px;
  padding-left: 32px;
  padding-right: 32px;
  border-radius: 3px;

  &.ant-btn-primary {
    background-color: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }

  &.ant-btn:not(.ant-btn-primary):not(.ant-btn-dangerous) {
    &:hover {
      border-color: ${({ theme }) => theme.primary};
      color: ${({ theme }) => theme.primary};
    }
  }
`;

export const Link = styled.div`
  color: ${({ theme }) => theme.primary};
`;
